export const replacePath = (path = '', source: string, target: string) => {
  if (!path.includes(source)) {
    return `${path}/${target}`.replace(/\/\//g, '/');
  }

  return path.replace(new RegExp(`/${source}`), `/${target}`).replace(/\/\//g, '');
};
